import { render } from "./OficiosEmbargoPersonaComponent.vue?vue&type=template&id=5a624b60"
import script from "./OficiosEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./OficiosEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__